<p-toast position="top-center" />

@if (userService.user()?.id && !isAuthUrl) {
<app-global-sidenav />
<app-global-navbar />

<main class="w-full h-full pt-[70px] pb-[100px]">
	<router-outlet />
	<app-global-toolbar />
</main>
} @if(['/auth', '/onboarding'].includes(router.url)) {
<main class="w-full h-full relative">
	<router-outlet />

	@if (router.url === '/auth') {
	<div class="absolute bottom-0 flex justify-center" style="width: 100%">
		<app-registered-mark />
	</div>
	}
</main>
}

<p-confirmdialog key="versionDialog"></p-confirmdialog>
